import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Mic, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function InterviewsPage() {
  const navigate = useNavigate();
  return (
    <div className="space-y-6">
      <div>
        <p className="text-[10px] font-heading uppercase tracking-[0.2em] text-[#3D1F6E] dark:text-[#A78BFA] font-semibold mb-1">
          Practice
        </p>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight font-heading">
          Mock Interviews
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          Practice with AI-powered mock interviews
        </p>
      </div>

      <Card className="bg-card border-border card-shadow">
        <CardContent className="flex flex-col items-center py-10 gap-4">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center icon-bg-violet">
            <Mic className="w-7 h-7" />
          </div>
          <div className="text-center space-y-1">
            <h3 className="text-base font-heading font-semibold">No interviews yet</h3>
            <p className="text-sm text-muted-foreground max-w-sm">
              Your mock interview sessions will appear here once you start practicing.
            </p>
          </div>
          <button
            className="mt-1 inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-semibold font-heading btn-cta"
            data-testid="start-interview-empty-btn"
            onClick={() => navigate('/interview/setup')}
          >
            Start Your First Interview
            <ArrowRight className="w-4 h-4" />
          </button>
        </CardContent>
      </Card>
    </div>
  );
}
